import type { MutableRefObject } from 'react';
import { useEffect } from 'react';

export function useOpenPanelHalfway(
  panel: unknown,
  scrollElementRef: MutableRefObject<HTMLElement | null>
) {
  useEffect(() => {
    if (panel && scrollElementRef) {
      const element = scrollElementRef?.current;
      if (element != null) {
        element.scrollTo(0, element.clientHeight / 2);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [panel]);
}
